<template lang="pug">
v-app
    v-navigation-drawer(:permanent="sidebarOpen" app floating :width="windowWidth < 512 ? '100vw' : 430")
        template
            //- .absolute.right-0.mr1
            //-     v-btn(small outlined)
            //-         v-icon mdi-chevron-left
            v-container
                v-row
                    v-col
                        .mt3-ns.mh2-ns.d-flex.flex-column(style="position:absolute; top:0; bottom:0; left:0;right:0;")
                            .flex-grow-0.flex-shrink-0.w-100
                                ServiceInfo(v-if="selectedService" :service="selectedService")
                                .mb3
                                    label Enter your address to find services.
                                #geocoder-container.mb1

                                Filters(v-if="center")
                            Results(:category="categories" :center="center" :windowWidth="windowWidth")


    v-main
        div(style="height: 100%; position:relative; flex:1 1;")
            Map(:categories="categories")
            v-btn.mt2.ml2(v-if="!sidebarOpen" color="primary" absolute top left @click="sidebarOpen = true")
                v-icon mdi-view-list
                span.ml2 Return to list
            v-btn.mt2.ml2(v-if="sidebarOpen && windowWidth > 670 && windowWidth < 900" color="primary" dark absolute top left @click="sidebarOpen = false")
                v-icon mdi-view-list
                span.ml2 Close sidebar


</template>

<script>
import 'tachyons/css/tachyons.min.css';
import Map from '@/components/Map.vue';
import { EventBus } from '@/EventBus';
import Filters from '@/components/Filters.vue';
import Results from '@/components/Results.vue';
import ServiceInfo from '@/components/ServiceInfo.vue';
export default {
    name: 'App',

    components: {
        Map,
        Results,
        Filters,
        ServiceInfo,
    },

    data: () => ({
        categories: null,
        center: window.location.hash.match(/dev/) ? [122.7, -20.47] : null, //, //null,
        selectedService: null,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        sidebarOpen: true,
    }),
    computed: {
        pageName() {
            return this.textPages[this.tab];
        },
    },
    created() {
        window.onresize = () => {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        };
        EventBus.$on(
            'filter-change',
            (categories) => (this.categories = categories)
        );
        EventBus.$on('geocoder-result', (e) => {
            this.center = e.result.center;
        });
        EventBus.$on('geocoder-clear', (e) => {
            this.center = null;
        });
        EventBus.$on(
            'service-click',
            (service) => (this.selectedService = service)
        );
        EventBus.$on('showOnMap', (item) => {
            this.sidebarOpen = false;
        });
        EventBus.$on('result-pin-click', () => (this.sidebarOpen = true));

        window.App = this;
    },
};
</script>

<style>
html {
    overflow-y: hidden;
}

.v-main__wrap .container {
    padding: 0;
}
</style>
